import { useEffect, useState } from "react";
import { Modal } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearState } from "../redux/config/sessionPersist";
import './flowCommon.css'

const ForceLogoutModal = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener("FORCE_LOGOUT", handler);
    return () => window.removeEventListener("FORCE_LOGOUT", handler);
  }, []);

  const handleOk = () => {
    setOpen(false);

    dispatch({ type: "LOGOUT_USER_DETAILS_SUCCESS" });
    clearState();
    localStorage.clear();
    navigate("/login");
  };

  return (
    <>
      <Modal
        open={open}
        onOk={handleOk}
        closable={false}
        maskClosable={false}
        okText="Ok"
        title="Logged Out"
          className="make-admin exper"
      >
        <p>You have been logged out from the system.</p>
        <p>Click OK to go back to the Login Screen.</p>
      </Modal>
    </>
  );
};

export default ForceLogoutModal;
